import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { onBeforeRouteUpdate } from 'vue-router/composables';
import { notification } from 'ant-design-vue';
import router from '@/router';
import i18n from '@/i18n';
import SettingsTopBar from '@/modules/CMS/layout/SettingsTopBar.vue';
import NotAllowedComponent from '@/modules/CMS/layout/NotAllowedComponent.vue';
import { RouteNames } from '@/enums/routes/RouteNames';
import { useUserRights } from '@/shared/composables/useUserRights';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleResources',
  setup(__props) {

const comp = ref<any>(null);
const name = ref('');
const userHasRights = ref(false);

const { canSeeCMSItem } = useUserRights();

async function updateComponent(param: any): Promise<void> {
    userHasRights.value = canSeeCMSItem.value;

    if (!userHasRights.value) {
        comp.value = null;
        return;
    }

    name.value =
        param === 'CalendarSchedules' || param === 'CalendarScheduleEdit'
            ? (i18n.t('Schedules') as string)
            : (i18n.t('Resources') as string);
    try {
        const module =
            param === 'CalendarResources'
                ? await import(`@/modules/CMS/views/${param}.vue`)
                : await import(`@/modules/CMS/components/${param}.vue`);
        comp.value = module.default;
    } catch (e) {
        notification.error({
            message: i18n.t('Dogodila se greška') as string,
            description: i18n.t('Ovaj proizvod ne postoji') as string,
        });
        router.push({ name: RouteNames.home });
    }
}

onBeforeRouteUpdate((to, _from, next) => {
    // When changing from one dynamic route to another
    updateComponent(to.params.dynamic);

    next();
});

onMounted(() => {
    // When first entering the route
    updateComponent(router.currentRoute.params.dynamic);
});

return { __sfc: true,comp, name, userHasRights, canSeeCMSItem, updateComponent, SettingsTopBar, NotAllowedComponent }
}

})